import { onlyStringArray, arrayToString } from 'app2/components'

import { GradeDropdown } from './GradeDropdown';
import { GradeText } from './GradeText';

export const GradeField = {edit: {component: GradeDropdown, separator: ',', placeholder:"Enter grade"}, display: {component: GradeText, none: false}};
export const MultipleGradeField = {edit: {...GradeField.edit, parse: onlyStringArray, multiple: true}, display: {...GradeField.display, copy: arrayToString}};